import getEmailAddressFromSipUri from '../../presenceManager/getEmailAddressFromSipUri';
import getPresenceFromStore from '../../presenceManager/getPresenceFromStore';
import tryRegisterForPresenceUpdates from '../../presenceManager/tryRegisterForPresenceUpdates';
import getRecipientDisplayName from '../selectors/getRecipientDisplayName';
import { observer } from 'mobx-react-lite';
import { PersonaSize } from '@fluentui/react/lib/Persona';
import PersonaControl from 'owa-persona/lib/components/PersonaControl';
import * as React from 'react';

const styles = require('./ChatHeaderGroupMemberList.scss');

interface ChatHeaderGroupMemberProps {
    sipUri: string;
}

const ChatHeaderGroupMember = observer(function ChatHeaderGroupMember(
    props: ChatHeaderGroupMemberProps
) {
    const { sipUri } = props;
    const emailAddress = getEmailAddressFromSipUri(sipUri);

    React.useEffect(() => {
        tryRegisterForPresenceUpdates(emailAddress);
    }, [emailAddress]);

    const presenceInfo = getPresenceFromStore(emailAddress);

    return (
        <div className={styles.chatContact}>
            <PersonaControl
                name={getRecipientDisplayName(sipUri)}
                className={styles.persona}
                emailAddress={emailAddress}
                size={PersonaSize.size24}
                showPersonaDetails={true}
                showPresence={true}
                presence={presenceInfo}
                showSecondaryText={false}
            />
        </div>
    );
});

export interface ChatHeaderGroupMemberListProps {
    participants: string[];
}

export default function ChatHeaderGroupMemberList(props: ChatHeaderGroupMemberListProps) {
    const { participants } = props;

    return (
        <>
            {participants.map(member => (
                <ChatHeaderGroupMember sipUri={member} key={member} />
            ))}
        </>
    );
}
